import { useState } from 'react';
import { Common } from '@thecvlb/design-system';

import { selectOrchestrate, selectSignUp } from 'store';

import DateAndTime from 'widgets/createAppointment/DateAndTime';

import { WM_FLOWS } from 'constants/onboarding';
import { useAppSelector } from 'hooks';
import { useFixPopupPadding } from 'hooks/useFixPopupPadding';
import useWidth from 'hooks/useWidth';
import { PlanCodes } from 'utils/enums';

import { NewAppointmentTimeModalProps } from './newAppointmentTime.types';

const NewAppointmentTime: React.FC<NewAppointmentTimeModalProps> = ({
  reason,
  onClose,
  isOpen,
  onConfirm,
  loading,
  persist = false,
  flow,
  bufferPeriodDays
}) => {
  const {
    membershipPlans,
    user: {
      accessToken,
      doctorId,
      planId,
      mailingAddress: { state: regularFlowState }
    },
    firstAppointment: { appointmentTypeId }
  } = useAppSelector(selectSignUp);
  const {
    appointment: { appointmentTypeId: wmAppointmentTypeId },
    user: { state },
    payment: { product_price_point_handle: productPricePointHandle }
  } = useAppSelector(selectOrchestrate);
  const { isMobile } = useWidth();
  const [time, setTime] = useState({ endTime: '', startTime: '' });
  const [newDoctorID, setNewDoctorID] = useState<string | null>(null);

  const WMPLan = membershipPlans.find((p) => p.planCode === PlanCodes.WeightManagementMembership);

  const isWMFlow = !!flow && WM_FLOWS.includes(flow);
  const getAlertContent = () => {
    if (reason === 'expired-slot') {
      return (
        <Common.Alert type="error" colorableBackground>
          <p
            className="font-bold leading-tight md:text-base md:font-semibold"
            data-testid="expired_slot"
          >
            Your chosen appointment time is no longer available.
            <span className="font-normal">{` Please choose another time below.`}</span>
          </p>
        </Common.Alert>
      );
    }
    return (
      <Common.Alert type="info" colorableBackground>
        <p className="text-sm">Please choose an appointment time.</p>
      </Common.Alert>
    );
  };

  useFixPopupPadding(isOpen);
  return (
    <Common.Modal
      autoScroll={isMobile}
      close={onClose}
      isOpen={isOpen}
      persist={persist}
      size="lg"
      zIndex={50}
    >
      <div className="mb-10 md:mb-8">{getAlertContent()}</div>
      <DateAndTime
        accessToken={accessToken}
        appointmentTypeId={appointmentTypeId || wmAppointmentTypeId}
        bufferPeriodDays={bufferPeriodDays}
        doctorId={doctorId}
        loading={loading}
        onboardingUserData={{
          planID: isWMFlow ? (WMPLan?._id ?? '') : planId,
          state: isWMFlow ? state : regularFlowState
        }}
        planPricePointId={productPricePointHandle}
        providerType={isWMFlow ? 'any' : 'my'}
        updateStartDate={(_, startTime, endTime, newProviderID) => {
          setTime({ endTime, startTime });
          if (newProviderID) {
            setNewDoctorID(newProviderID);
          }
        }}
        isReschedule
        isSignUp
        onSelect={() => onConfirm(time, newDoctorID)}
      />
    </Common.Modal>
  );
};

export default NewAppointmentTime;
